import axios from '@fs/zion-axios'
import SERVICE from './serviceName'
import { sessionMetricsConfig } from '../../config/sessionMetrics'

// DOCS: https://icseng.atlassian.net/wiki/x/4Ir2Bw

const BASE = `${SERVICE}/session-metrics`
const axiosConfig = { headers: { 'Content-Type': 'application/json' }, data: {} }

export const getUserSessionRating = async ({ sessionId, cisId }) => {
  return axios.get(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, axiosConfig)
}

export const deleteUserSessionRating = async ({ sessionId, cisId }) => {
  return axios.delete(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, axiosConfig)
}

export const getSessionMetrics = async ({ sessionId }) => {
  return axios.get(`${BASE}/sessions/${sessionId}`, axiosConfig)
}
export const getSessionRatings = async ({ sessionId }) => {
  return axios.get(`${BASE}/sessions/${sessionId}/ratings`, axiosConfig)
}

export const getUserRatings = async () => {
  return axios.get(`${BASE}/sessions`, axiosConfig)
}

export const updateUserSessionRatings = async ({ sessionId, cisId }, body) => {
  return axios.put(`${BASE}/sessions/${sessionId}/ratings/${cisId}`, body, axiosConfig)
}

export const getTopRatedSessionsByLanguage = async ({ lang }) => {
  return axios.get(`${BASE}/popular-sessions/${lang}`, axiosConfig)
}

export const getTopWatchedSessionsByLanguage = async ({ lang, from, until, limit }) => {
  const langLimit =
    limit ?? sessionMetricsConfig.watchedLimitByLanguage[lang] ?? sessionMetricsConfig.defaultWatchedLimit
  const params = new URLSearchParams()
  if (from) params.append('from', from)
  if (until) params.append('until', until)
  params.append('limit', langLimit)
  return axios.get(`${BASE}/top-watched-sessions/${lang}?${params.toString()}`, axiosConfig)
}
